import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { FINISH } from '../../finish.tokens';

/* --------------------------- demo express checkout -------------------------- */

export const Card = styled.div`
  border-radius: 16px;
  background: ${FINISH.expressCardBg};
  padding: 12px;
`;

export const SmallLabel = styled(Text)`
  font-size: 14px;
  color: ${CFG.base400};
`;

export const SmallLabelTop = styled(SmallLabel)`
  margin-top: 16px;
`;

export const ExpressGrid = styled.div`
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`;

export const ExpressLink = styled.span`
  display: flex;
  height: 45px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${FINISH.expressLinkBg};
`;

export const ExpressAmazon = styled.span`
  display: flex;
  height: 45px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${FINISH.expressAmazonBg};
`;

export const LinkIcon = styled.img`
  height: 20px;
  width: auto;
`;

export const AmazonIcon = styled.img`
  height: 24px;
  width: auto;
`;

export const MethodList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/* ------------------------------- a method row ------------------------------ */

export const MethodRow = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  border: 1px solid ${FINISH.methodRowBorder};
  background: ${FINISH.methodRowBg};
  padding: 0 12px;
`;

export const MethodIcon = styled.span`
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
`;

export const MethodIconImg = styled.img`
  width: 22px;
  height: 22px;
`;

export const MethodLabel = styled(Text)`
  font-size: 16px;
  color: ${FINISH.methodLabel};
`;

export const DemoNote = styled(Text)`
  margin-top: 12px;
  text-align: center;
  font-size: 14px;
  color: ${FINISH.demoNote};
`;

/* ------------------------------ live / loading ----------------------------- */

export const LiveExtra = styled.div`
  margin-top: 12px;
`;

export const StatusBox = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 20px;
`;

/**
 * Standard animated Whitelabels.com loader shown while the secure-checkout invoice is prepared (the
 * reconcile can wait out a multi-second invoice reissue, so this signals the app is still working).
 * It's the SAME hosted SVG the app boots with and the device previews use. The art is white for the
 * dark pane; on the light pane `brightness(0)` recolours it to a black silhouette (per-bar alpha
 * preserved, so the loading rhythm survives the recolour) — matching the preview placeholder.
 */
export const Spinner = styled.img<{ $onLight: boolean }>`
  width: 64px;
  height: 64px;
  display: block;
  object-fit: contain;
  filter: ${({ $onLight }) => ($onLight ? 'brightness(0)' : 'none')};
`;

export const StatusText = styled(Text)`
  font-size: 14px;
  color: ${CFG.base500};
`;
